<template>
  <div class="login-bg">
    <div class="banner">
      <div class="container-fluid">
        <div class="row align-items-center login mx-2">
          <div class="col-md-7"></div>
          <div class="col-md-5 col-12 ">
            <div>
              <div class="form-box">
                <img style="width: 60%; min-width:300px" src="../assets/image/LOGO-mag.png" alt="">
                <div class="mt-5">
                  <form class="mt-4 px-4" v-if="!forget">
                    <div class="group">
                      <input class="input-text" v-on:keyup.enter="login" v-model="auth.account" type="text" required>
                      <span class="highlight"></span>
                      <span class="bar"></span>
                      <label class="input-text-label">{{ $t('Login.please_enter_your_email') }}</label>
                    </div>
                    <div class="group">
                      <input class="input-text" v-on:keyup.enter="login" v-model="auth.password" type="password" required>
                      <span class="highlight"></span>
                      <span class="bar"></span>
                      <label class="input-text-label">{{ $t('Login.please_enter_password') }}</label>
                    </div>
                    <div>
                      <div class="form-check">
                        <input class="form-check-input" type="checkbox" id="checkbox1" v-model="remember">
                        <span class="form-check-label" for="checkbox1">
                          記住我
                        </span>
                      </div>
                      <button type="button" style="width:100%" class="btn btn-danger mt-2" @click="login">{{ $t('Login.login') }}</button>
                    </div>
                    <div class="mt-2" style="text-align: right;">
                      <span class="underLine pointer" @click="openForgetPage">
                        {{ $t('Login.forgot_Password') }}
                      </span>
                    </div>
                  </form>
                  <form class="mt-4 px-4" v-else>
                    <div class="group">
                      <input class="input-text" v-model="auth.account" type="text" required>
                      <span class="highlight"></span>
                      <span class="bar"></span>
                      <label class="input-text-label">{{ $t('Login.please_enter_your_email') }}</label>
                    </div>
                    <div class="d-flex justify-content-between">
                      <button type="button" style="width:150px;" class="btn btn-danger" @click="getEmail">{{ $t('Login.send_verification_email') }}</button>
                      <button type="button" style="width:150px;" class="btn btn-danger" @click="forget = false">返回</button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// @ is an alias to /src
// import Video from '@/components/Video.vue'
import api from '../store/api'
import { mapActions, mapGetters } from 'vuex'
export default {
  name: 'MagLogin',
  data () {
    return {
      // toggle: false,
      auth: {
        account: '',
        password: '',
      },
      forget: false,
      remember: window.localStorage.getItem('account') ? true : false,
      groupList: {},
      count: 0
    }
  },
  props: {
    assistData: {
    }
  },
  computed: {
    ...mapGetters([
      'isLoading',
      'authorized',
      'authInfo'
    ]),
    accessRole () {
      if (this.$store.state.auth.user.aiOnly === true) {
        return false
      }else {
        return true
      }
    }
  },
  mounted () {
    if (this.remember) {
      this.auth.account = window.localStorage.getItem('account')
    }
    if (this.authorized) {
      this.$router.push({ path: 'home' })
    }
  },
  methods: {
    ...mapActions({
      dologin: 'login',
      getUser: 'getUser',
    }),
    async login () {
      const vm = this
      try {
        await this.dologin({ email: this.auth.account, password: this.auth.password })
        await this.getUser()
        if (this.remember) {
          window.localStorage.setItem('account', vm.auth.account)
        } else {
          window.localStorage.removeItem('account')
        }
        if (this.authInfo.user.isFirstLogin) {
          this.$router.push({ name: 'First-login' })
        } else {
          if (this.accessRole) {
            this.$router.push({ name: 'Home' })
          } else {
            this.$router.push({ name: 'ai_assistantIntro' })
          }
        }
      } catch (error) {
        // if (error) {
        //   this.setTimeout(
        //     this.$swal({
        //     title: '登入失敗',
        //     text: error.response.data.message,
        //     icon: 'error',
        //     showCancelButton: false,
        //     confirmButtonText: '確定'
        //   })
        //   , 1000)
        // }
      }
    },
    async getEmail () {
      try {
        const {data} = await api.post(`password/email?email=${this.auth.account}`)
        this.$swal({
          title: data.email || data.status,
          icon: 'info',
          showCancelButton: false,
          confirmButtonText: '確定'
        })
      } catch (error) {
        this.$swal({
          title: error.response.data.errors.email[0],
          icon: 'error',
          showCancelButton: false,
          confirmButtonText: '確定'
        })
      }
    },
    openForgetPage () {
      this.forget = true
      this.auth.account = ''
    }
  },
  components: {
    // Video
  }
}
</script>
<style lang="scss" scoped>
@import "../assets/styles/custom.scss";
  .group {
    position:relative;
    margin-bottom: 35px;
    input {
      font-size: 18px;
      padding: 10px 10px 10px 5px;
      display: block;
      width: 100%;
      border: none;
      border-bottom: 1px solid #757575;
    }
    input:focus	{ outline: none; }
    .my-select {
      margin: 5% auto !important;
    }
  }
  .form-check {
    float: left;
  }

  /* LABEL ======================================= */
  label {
    color: #999;
    font-size: 18px;
    font-weight: normal;
    position: absolute;
    pointer-events: none;
    left: 5px;
    top: 10px;
    transition: 0.2s ease all;
    -moz-transition: 0.2s ease all;
    -webkit-transition: 0.2s ease all;
  }

  /* active state */
  input:focus ~ label, input:valid ~ label {
    top: -20px;
    font-size: 14px;
    color: #000000;
  }
  .arrow {
    width: 50px;
  }
  /* BOTTOM BARS ================================= */
  .bar {
    position:relative;
    display:block;
    width:100%;
  }
  .bar:before, .bar:after {
    content: '';
    height: 2px;
    width: 0;
    bottom: 1px;
    position: absolute;
    background: #000000;
    transition: 0.2s ease all;
    -moz-transition: 0.2s ease all;
    -webkit-transition: 0.2s ease all;
  }
  .bar:before {
    left: 50%;
  }
  .bar:after {
    right: 50%;
  }

  /* active state */
  input:focus ~ .bar:before, input:focus ~ .bar:after {
    width: 50%;
  }
  .underLine {
    text-decoration: underline;
  }
  .banner {
    background-repeat: no-repeat;
    background-size: cover;
    //background-position: center;
    height: 100vh;
    background-image: url('../assets/image/bg_main_L.jpg');
    .container-fluid {
      height: 100vh;
      .login {
        height: 100vh;
        text-align: center;
        .form-box {
          min-width: 300px;
          max-width: 35vw;
          width: 100%;
          height: 50vh;
          margin: 25% 0;
        }
        .title {
          color: black;
          margin-top: 20px;
          font-size: 3rem;
          font-weight: 1000;
        }
      }
    }
  }
  .topic-banner {
    //background-image: url('../assets/image/home/bg_theme_L.jpg');
    .title {
      color: black;
      margin-top: 20px;
      font-size: 2.5rem;
      font-weight: 1000;
    }
  }
  .feature-banner {
    padding: 200px 0;
    //background-image: url('../assets/image/home/bg_info_M.jpg');
    .title {
      color: black;
      margin: 20px 0;
      font-size: 2.5rem;
      font-weight: 1000;
    }
    .feature-box {
      margin: auto;
      width: 70%;
      font-size: 1.25rem;
      .red-text {
        color: red;
      }
    }
  }
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
  @media screen and (max-width: 600px) {
    .banner {
      background-position: 100%;
    }
    .form-box {
      width: 100% !important;
    }
  }
</style>
